export default "__VITE_ASSET__Ba2TkvEQ__"